import Calculator from "./components/Calculator";

function App() {
  return (
    <div className="App flex justifyCenter itemsCenter">
      <Calculator />
    </div>
  );
}

export default App;
